// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"54107563","413":"b182cccc","963":"8d177c08","988":"df143505"}[chunkId] + ".chunk.js";
};